import { format, subWeeks } from 'date-fns'

export const DASHBOARD_ALERT_KEYWORDS = [
  'Harcèlement',
  'Agression',
  'Burn out',
  'Bore out',
  'Brown out',
  'Violence',
  'Dépression',
  'Démission',
  'Anxiété',
  'Intimidation',
  'Discrimination',
  'Humiliation',
  'Toxique',
  'Sexisme',
  'Souffrance',
  'Maltraitance',
  'Chantage',
  'Stress',
  'Licenciement',
  'Suicide'
]

export const DASHBOARD_QUICK_RANGES = [
  { id: 'week-1', label: '1 semaine', type: 'week', amount: 1 },
  { id: 'day-15', label: '15 jours', type: 'day', amount: 15 },
  { id: 'month-1', label: '1 mois', type: 'month', amount: 1 },
  { id: 'month-3', label: '3 mois', type: 'month', amount: 3 },
  { id: 'month-6', label: '6 mois', type: 'month', amount: 6 }
]

export function createDashboardState () {
  const today = new Date()
  const storage = typeof window !== 'undefined' ? window.localStorage : null
  const getStoredValue = (key) => {
    if (!storage) {
      return null
    }
    try {
      return storage.getItem(key)
    } catch (error) {
      return null
    }
  }
  const parseStoredBoolean = (value) => {
    if (value === null || value === undefined) {
      return null
    }
    try {
      const parsed = JSON.parse(value)
      return typeof parsed === 'boolean' ? parsed : null
    } catch (error) {
      if (value === 'true') {
        return true
      }
      if (value === 'false') {
        return false
      }
      return null
    }
  }
  const readCollapsePreference = (primaryKey, fallbackKeys = []) => {
    const keys = [primaryKey, ...fallbackKeys]
    for (const key of keys) {
      const stored = getStoredValue(key)
      const parsed = parseStoredBoolean(stored)
      if (parsed !== null) {
        return parsed
      }
    }
    return false
  }

  const storedStart = getStoredValue('dateStart')
  const storedEnd = getStoredValue('dateEnd')
  const defaultEnd = storedEnd || format(today, 'yyyy-MM-dd')
  const defaultStart = storedStart || format(subWeeks(today, 1), 'yyyy-MM-dd')

  return {
    loaded: false,
    loadingGraphs: true,
    loadingPopularities: true,
    isLoadingExport: false,
    isDownloadingLastSurveyStats: false,
    loadingPendingNews: true,
    loadingMavieproNews: true,
    loadingPendingSurveys: true,
    loadingMavieproSurveys: true,
    loadingActiveSurveys: true,
    loadingReadTracking: true,
    duplicatingMavieproArticle: false,
    duplicatingMavieproSurvey: false,
    isOpeningArticleModal: false,
    isOpeningSurveyModal: false,
    collapsedLines: {
      overview: readCollapsePreference('dash_collapsed_line_overview', [
        'dash_downloadsCollapsed',
        'dash_loginsCollapsed'
      ]),
      insights: readCollapsePreference('dash_collapsed_line_insights', [
        'dash_collapsed_topNews',
        'dash_collapsed_topFaqs',
        'dash_collapsed_topKeywords',
        'dash_collapsed_activeSurveys'
      ]),
      news: readCollapsePreference('dash_collapsed_line_news', [
        'dash_collapsed_pendingNews',
        'dash_collapsed_mavieproNews'
      ]),
      surveys: readCollapsePreference('dash_collapsed_line_surveys', [
        'dash_collapsed_pendingSurveys'
      ])
    },
    isLayoutEditMode: false,
    draggingColumn: null,
    draggingId: null,
    defaultRightCardOrder: ['topFaqs', 'topNews', 'activeSurveys', 'topKeywords'],
    rightCardOrder: [],
    stats: null,
    graphs: null,
    popularity: {
      faqs: [],
      searches: [],
      categories: [],
      totals: {
        searches: {
          period: 0
        }
      }
    },
    counters: {
      total: {
        users: 0,
        faqViews: 0,
        newsViews: 0,
        loginsUniq: 0
      },
      period: {
        users: 0,
        faqViews: 0,
        newsViews: 0,
        loginsUniq: 0
      }
    },
    chartUsersData: null,
    chartLoginsData: null,
    employeeActivityTotals: {
      workforce: 0,
      downloadsPeriod: 0,
      downloadsCumulative: 0,
      downloadRateWorkforce: 0,
      downloadRateAverage: 0,
      activeLogins: 0,
      activeUsers: 0,
      activeUsersRowSum: 0,
      activeUsersRateDownloads: 0,
      activeUsersRateAverage: 0
    },
    employeeActivityDailySeries: [],
    readTrackingDailySeries: [],
    readTrackingTotals: null,
    loginsSeries: [],
    topNewsItems: [],
    dateStart: defaultStart,
    dateEnd: defaultEnd,
    dateRange: [defaultStart, defaultEnd],
    today,
    todayFormatted: format(today, 'yyyy-MM-dd'),
    selectedTrackingYear: today.getFullYear(),
    monthlyTrackingSeries: [],
    isMonthlyTrackingOpen: false,
    isMonthlyTrackingLoading: false,
    domainStartDate: null,
    quickRanges: DASHBOARD_QUICK_RANGES.map(range => ({ ...range })),
    activeQuickRangeId: null,
    selectedAlertKeyword: null,
    mockEmployeeTargets: {
      totalEmployees: null,
      manualOverride: null
    },
    lastLoadedDomainUuid: null,
    newsPublishedCount: null,
    newsPublishedTotalCount: null,
    loadingPublishedNews: false,
    loadingTopNews: true,
    activeSurveysRaw: [],
    pendingNewsRaw: [],
    mavieproNewsRaw: [],
    pendingSurveysRaw: [],
    mavieproSurveysRaw: [],
    pendingSurveysTotal: 0,
    activeSurveysTotal: 0,
    lastEndedSurveyRaw: null,
    surveysOverviewMeta: null,
    alertKeywordsReference: DASHBOARD_ALERT_KEYWORDS.slice(),
    numberFormatter: new Intl.NumberFormat('fr-FR')
  }
}
